import {
  CalculateTour,
  CalculateTourStats,
} from '@/domain/impact-calculate-tour/entities/calculate-tour.entity';
import {
  CalculateTourCo2,
  EMPTY_CALCULATE_TOUR_CO2,
} from '@/domain/impact-calculate-tour/entities/calculate-tour-co2.entity';
import {
  CalculateTourEnv,
  EMPTY_CALCULATE_TOUR_ENV,
} from '@/domain/impact-calculate-tour/entities/calculate-tour-env.entity';
import {
  CalculateTourEss,
  EMPTY_CALCULATE_TOUR_ESS,
} from '@/domain/impact-calculate-tour/entities/calculate-tour-ess.entity';
import { ImpactCalculateTourGateway } from '@/domain/impact-calculate-tour/gateways/impact-calculate-tour.gateway';

export class ApiImpactCalculateTourFakeGateway implements ImpactCalculateTourGateway {
  async runImpactCalculateTourCo2ForProject(): Promise<void> {
    await new Promise((r) => setTimeout(r, 500));
  }

  async runImpactCalculateTourCo2ForSequence(): Promise<void> {
    await new Promise((r) => setTimeout(r, 500));
  }

  async runImpactCalculateTourEnvForProject(): Promise<void> {
    await new Promise((r) => setTimeout(r, 500));
  }

  async runImpactCalculateTourEssForProject(): Promise<void> {
    await new Promise((r) => setTimeout(r, 500));
  }

  async getTourResultsForProject(): Promise<CalculateTour> {
    await new Promise((r) => setTimeout(r, 500));
    return {
      co2: FAKE_CALCULATE_TOUR_CO2,
      env: FAKE_CALCULATE_TOUR_ENV,
      ess: FAKE_CALCULATE_TOUR_ESS,
      stats: FAKE_CALCULATE_TOUR_STATS,
    };
  }
}

const FAKE_CALCULATE_TOUR_CO2: CalculateTourCo2 = {
  global: {
    score: 12.5,
  },
  general: {
    score: 12.5,
    sections: EMPTY_CALCULATE_TOUR_CO2.general.sections,
  },
  ontour: {
    score: 12.5,
    bySequence: {
      25: {
        score: 12.5,
        events: 12.5,
        travels: 12.5,
        variousCost: {
          score: 12.5,
          sectors: {
            artists: {
              categories: {
                accommodation: {
                  score: 12.5,
                },
                catering: {
                  score: 12.5,
                },
                equipment: {
                  score: 12.5,
                },
              },
            },
          },
        },
      },
    },
    byTourEvent: {
      44: {
        score: 12.5,
      },
    },
    byTourTravel: {
      56: {
        score: 12.5,
      },
    },
  },
};

const FAKE_CALCULATE_TOUR_ENV: CalculateTourEnv = {
  general: {
    scoreLetter: 'B',
    score: 54.25,
    maxScore: 86.5,
    topics: EMPTY_CALCULATE_TOUR_ENV.general.topics,
  },
};

const FAKE_CALCULATE_TOUR_ESS: CalculateTourEss = {
  general: {
    scoreLetter: 'C',
    score: 45,
    maxScore: 67,
    topics: EMPTY_CALCULATE_TOUR_ESS.general.topics,
  },
};

const FAKE_CALCULATE_TOUR_STATS: CalculateTourStats = {
  ontour: {
    bySequence: {
      25: {
        eventCount: 10,
        co2AveragePerEvent: 12.5,
      },
    },
    byTourTravel: {
      56: {
        passengerCount: 10,
        weight: 12.5,
      },
    },
  },
};
